import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import { basketActions } from '../redux/basket/actions/BasketActions.creators';
import { PromoBasketPopupCTA } from '../components/promo-basket-popup/PromoBasketPopupCTA';
const PromoBasketPopupCTAContainer = ({ addToBasket, closePopup }) => (_jsx(PromoBasketPopupCTA, { addToBasket: addToBasket, closePopup: closePopup }));
const mapDispatchToProps = {
    addToBasket: basketActions.createBasicAddAction,
};
export default connect(null, mapDispatchToProps)(PromoBasketPopupCTAContainer);
